import { useMatch, useLocation } from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
} from "@/components/ui/breadcrumb";
import { LeaguesBreadcrumb } from "features/leagues-v2/components/LeaguesBreadcrumb";
import { EventsBreadcrumb } from "features/competitions/components/EventsBreadcrumb";

const ROUTE_LABELS: Record<string, string> = {
  "/dashboard": "Control",
  "/competitions": "Competitions",
  "/events": "Events",
  "/reservations": "Reservations",
  "/leagues": "Leagues",
  "/marketing": "Marketing Hub",
  "/lockerroom": "Locker Room",
  "/ad-spaces": "Ad Spaces",
  "/admin": "Clubhouse Admin",
  "/settings": "Settings",
};

export function AppBreadcrumb() {
  const { pathname } = useLocation();
  const isInLeagues = !!useMatch({ path: "/leagues", end: false });
  // Only the sub-pages: the bare /events keeps its ROUTE_LABELS crumb, which
  // carries the brand-text styling every other top-level page uses.
  const isInEvents = !!useMatch({ path: "/events/:eventId", end: false });

  return (
    <Breadcrumb className="min-w-0">
      <BreadcrumbList className="min-w-0 flex-nowrap">
        {isInLeagues ? (
          <LeaguesBreadcrumb />
        ) : isInEvents ? (
          <EventsBreadcrumb />
        ) : (
          <BreadcrumbItem>
            <BreadcrumbPage className="brand-text">
              {ROUTE_LABELS[pathname] ?? ""}
            </BreadcrumbPage>
          </BreadcrumbItem>
        )}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
